import React from 'react';
import { evangelismMyths, firstSteps } from '../data/content';
import { CtaButton } from './CtaButton';
import { HeartMark } from './decor/HeartMark';
export function ShynessObjection() {
  return <section aria-labelledby="shy-title" className="bg-cream" data-id="element-293" data-mp="25awpjanh9ko">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-294" data-mp="27ndvu8l3fwo">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-16" data-id="element-295" data-mp="3tblwzd7u66ay">
          <div data-id="element-296" data-mp="3odajmsic1dnz">
            <h2 id="shy-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-297" data-mp="3odu3ierjmc4n">
              Your Shyness Doesn’t Have to Stop Your Obedience
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-298" data-mp="3flie8w860uq9">Maybe you’ve thought evangelism was only for…</p>
            <ul className="mt-4 space-y-2.5" data-id="element-299" data-mp="3angv6baqoves">
              {evangelismMyths.map(m => <li key={m} className="text-lg text-ink-mute line-through decoration-coral/60 decoration-2" data-id="element-300" data-mp="35m1awlgdysxg">
                  {m}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[28px] bg-white p-8 shadow-card ring-1 ring-cream-line sm:p-10" data-id="element-301" data-mp="8m11di5ns01m">
            <p className="text-lg font-bold leading-relaxed text-navy" data-id="element-302" data-mp="dfveg2qrdgrq">But the Great Commission wasn’t given only to pastors and missionaries.</p>
            <p className="mt-3 text-lg leading-relaxed text-ink-soft" data-id="element-303" data-mp="3o96qgdmpztq">And you don’t have to wait until every fear disappears before you begin.</p>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-304" data-mp="remqzkpz2udr">Sometimes the first step is simply being willing to share:</p>
            <ul className="mt-4 space-y-1" data-id="element-305" data-mp="watxbema67w8">
              {firstSteps.map(s => <li key={s} className="flex items-center gap-3 font-display text-3xl text-navy" data-id="element-306" data-mp="hi07az9du9db">
                  <HeartMark className="h-4 w-4 text-coral" data-id="element-307" data-mp="mh3din13mlmv" />
                  {s}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-16 max-w-2xl text-center" data-id="element-308" data-mp="376ajn3xye0qr">
          <p className="text-lg leading-relaxed text-ink-soft" data-id="element-309" data-mp="1dm8z2ioyaq10">The Gospel Sharing Mega Bundle gives you a simple tool to help you take that first step.</p>
          <p className="mt-4 font-display text-[28px] leading-tight text-navy sm:text-[34px]" data-id="element-310" data-mp="18nxog5qu0bhq">
            Because you may not always know exactly what to say…
            <span className="block italic text-coral" data-id="element-311" data-mp="yy4awz74pmau">But you can always be ready to plant a seed.</span>
          </p>
          <CtaButton className="mt-8" data-id="element-312" data-mp="tzknsvgsu4gw">Start Sharing the Gospel</CtaButton>
        </div>
      </div>
    </section>;
}